/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ event: NonNullable<unknown>, url: NonNullable<unknown> }} Email_Reminder_TextInputs */

const th_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} กำลังจะเริ่มขึ้น

ดูตารางเวลาแข่งขัน: ${i?.url}

คุณได้รับอีเมลนี้เพราะติดตามรายการแข่งขันนี้ เปลี่ยนการแจ้งเตือนได้ในหน้าโปรไฟล์`)
};

const en_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} starts soon.

Check the schedule for tip-off times: ${i?.url}

You are receiving this because you follow this event. Change what you receive in your profile.`)
};

const ja_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} がまもなく始まります。

試合開始時刻はスケジュールをご覧ください: ${i?.url}

このメールは、この大会をフォローしているため送信されています。受信設定はプロフィールから変更できます。`)
};

const zh_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 即将开始。

赛程中有开球时间：${i?.url}

你收到这封邮件，是因为关注了该赛事。可在个人资料中更改接收内容。`)
};

const es_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} empieza pronto.

Consulta el calendario para ver las horas de inicio: ${i?.url}

Recibes esto porque sigues este evento. Cambia lo que recibes en tu perfil.`)
};

const pt_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} começa em breve.

Veja o calendário para os horários: ${i?.url}

Você recebe isto porque segue este evento. Mude o que recebe no seu perfil.`)
};

const id_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} segera dimulai.

Jadwal berisi waktu tip-off: ${i?.url}

Anda menerima ini karena mengikuti acara tersebut. Ubah yang Anda terima di profil Anda.`)
};

const fr_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} commence bientôt.

Consultez le calendrier pour les horaires : ${i?.url}

Vous recevez ceci parce que vous suivez cet événement. Modifiez ce que vous recevez dans votre profil.`)
};

const tl_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Malapit nang magsimula ang ${i?.event}.

Nasa iskedyul ang mga oras ng tip-off: ${i?.url}

Natatanggap mo ito dahil sinusundan mo ang event na iyon. Baguhin sa profile mo ang natatanggap mo.`)
};

const vi_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} sắp bắt đầu.

Lịch thi đấu có giờ bóng lên rổ: ${i?.url}

Bạn nhận được thư này vì đang theo dõi sự kiện đó. Đổi những gì bạn nhận trong hồ sơ của bạn.`)
};

const ko_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}이(가) 곧 시작합니다.

일정에 경기 시작 시각이 있습니다: ${i?.url}

해당 이벤트를 팔로우하고 있어 이 메일을 받으셨습니다. 받을 내용은 프로필에서 바꿀 수 있습니다.`)
};

const de_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} beginnt bald.

Die Anwurfzeiten stehen im Spielplan: ${i?.url}

Du bekommst das, weil du diesem Event folgst. Ändere in deinem Profil, was du bekommst.`)
};

const ru_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} скоро начнётся.

Время начала матчей есть в расписании: ${i?.url}

Вы получили это письмо, потому что подписаны на это событие. Что именно получать, меняется в вашем профиле.`)
};

const tr_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} yakında başlıyor.

Başlama saatleri fikstürde: ${i?.url}

Bu etkinliği takip ettiğiniz için bunu alıyorsunuz. Ne alacağınızı profilinizden değiştirin.`)
};

const it_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} sta per iniziare.

Gli orari di palla a due sono nel calendario: ${i?.url}

Ricevi questo messaggio perché segui quell'evento. Puoi cambiare cosa ricevere dal tuo profilo.`)
};

const pl_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} wkrótce się zaczyna.

Godziny rozpoczęcia są w terminarzu: ${i?.url}

Dostajesz tę wiadomość, bo obserwujesz to wydarzenie. Zmień, co otrzymujesz, w swoim profilu.`)
};

const uk_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} скоро починається.

Час початку матчів є в розкладі: ${i?.url}

Ви отримали цей лист, бо стежите за цією подією. Змініть, що саме отримувати, у своєму профілі.`)
};

const hi_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} जल्द शुरू हो रहा है।

शुरू होने के समय कार्यक्रम में हैं: ${i?.url}

आपको यह इसलिए मिला क्योंकि आप उस आयोजन को फ़ॉलो करते हैं। आप क्या पाते हैं, यह अपनी प्रोफ़ाइल में बदलें।`)
};

const ar_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} على وشك البدء.

مواعيد البدء في الجدول: ${i?.url}

وصلك هذا لأنك تتابع تلك الفعالية. غيّر ما تتلقاه من ملفك الشخصي.`)
};

const ms_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} akan bermula tidak lama lagi.

Waktu mula ada dalam jadual: ${i?.url}

Anda menerima ini kerana mengikuti acara itu. Ubah apa yang anda terima dalam profil anda.`)
};

const bn_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} শীঘ্রই শুরু হচ্ছে।

শুরুর সময় সূচিতে আছে: ${i?.url}

আপনি এটি পেয়েছেন কারণ আপনি ওই আয়োজন অনুসরণ করেন। কী পাবেন তা নিজের প্রোফাইলে বদলান।`)
};

const zh_tw2_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 即將開始。

賽程中有開賽時間：${i?.url}

你收到這封信，是因為你追蹤了該賽事。可在個人資料中變更接收內容。`)
};

const zh_hk2_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 即將開始。

賽程中有開賽時間：${i?.url}

你收到這封信，是因為你追蹤了該賽事。可在個人資料中變更接收內容。`)
};

const ur_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} جلد شروع ہو رہا ہے۔

شروع ہونے کے اوقات شیڈول میں ہیں: ${i?.url}

یہ آپ کو اس لیے ملا کہ آپ اس ایونٹ کو فالو کرتے ہیں۔ آپ کیا وصول کرتے ہیں، اپنے پروفائل میں بدلیں۔`)
};

const fa_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} به‌زودی آغاز می‌شود.

زمان‌های شروع در برنامه آمده است: ${i?.url}

این را دریافت کردید چون آن رویداد را دنبال می‌کنید. آنچه دریافت می‌کنید را در نمایهٔ خود تغییر دهید.`)
};

const sw_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} unakaribia kuanza.

Nyakati za kuanza zipo kwenye ratiba: ${i?.url}

Unapokea hii kwa sababu unalifuatilia tukio hilo. Badilisha unachopokea kwenye wasifu wako.`)
};

const nl_email_reminder_text = /** @type {(inputs: Email_Reminder_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} begint binnenkort.

De aanvangstijden staan in het schema: ${i?.url}

Je krijgt dit omdat je dat evenement volgt. Wijzig in je profiel wat je ontvangt.`)
};

/**
* | output |
* | --- |
* | "{event} starts soon. Check the schedule for tip-off times: {url} You are receiving this because you follow this event. Change what you receive in your profile." |
*
* @param {Email_Reminder_TextInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_reminder_text = /** @type {((inputs: Email_Reminder_TextInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Reminder_TextInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_reminder_text(inputs)
	if (locale === "ja") return ja_email_reminder_text(inputs)
	if (locale === "zh") return zh_email_reminder_text(inputs)
	if (locale === "es") return es_email_reminder_text(inputs)
	if (locale === "pt") return pt_email_reminder_text(inputs)
	if (locale === "id") return id_email_reminder_text(inputs)
	if (locale === "fr") return fr_email_reminder_text(inputs)
	if (locale === "tl") return tl_email_reminder_text(inputs)
	if (locale === "vi") return vi_email_reminder_text(inputs)
	if (locale === "ko") return ko_email_reminder_text(inputs)
	if (locale === "de") return de_email_reminder_text(inputs)
	if (locale === "ru") return ru_email_reminder_text(inputs)
	if (locale === "tr") return tr_email_reminder_text(inputs)
	if (locale === "it") return it_email_reminder_text(inputs)
	if (locale === "pl") return pl_email_reminder_text(inputs)
	if (locale === "uk") return uk_email_reminder_text(inputs)
	if (locale === "hi") return hi_email_reminder_text(inputs)
	if (locale === "ar") return ar_email_reminder_text(inputs)
	if (locale === "ms") return ms_email_reminder_text(inputs)
	if (locale === "bn") return bn_email_reminder_text(inputs)
	if (locale === "zh-TW") return zh_tw2_email_reminder_text(inputs)
	if (locale === "zh-HK") return zh_hk2_email_reminder_text(inputs)
	if (locale === "ur") return ur_email_reminder_text(inputs)
	if (locale === "fa") return fa_email_reminder_text(inputs)
	if (locale === "sw") return sw_email_reminder_text(inputs)
	if (locale === "nl") return nl_email_reminder_text(inputs)
	return en_email_reminder_text(inputs)
});